import React, { useState, useEffect, useContext } from 'react'
import {
  Button,
  Header,
  Icon,
  Modal,
  Segment,
  Message,
  List,
  Grid,
  GridRow,
  GridColumn,
} from 'semantic-ui-react'
import Swal from 'sweetalert2'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import contains from 'validator/es/lib/contains'

// eslint-disable-next-line no-unused-vars
import { CreateDeviceCreateTemplateXlsx } from '../../../services/asset'
import { uploadAssetFile } from '../../../services/configuration-template'
import { CreateXlsx } from '../../../services/xlsx'
import { primaryColor } from '../../../constants'
import IntelMsg from '../../ItelMsg/index'
import { RefreshCustomerDeviceList } from '../../../redux/actions/devices'
import { GetAllCustomers, getHierarchy } from '../../../services/customer'
import levelCreation from '../../../dummies/Level-Creation-Template-Site.xlsx'
import levelCreationRegion from '../../../dummies/Level-Creation-Template1.xlsx'
import { CustomerViewContext } from '../../customers/actions/customer-info-view/customerView'

const initialState = {
  assetType: 'site',
  fromId: '',
}
let tenantId = ''
let productType = ''

const AssetsBulkUpload = (props) => {
  const { customerSettings } = useContext(CustomerViewContext)
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  if (userEmail) {
    const products = JSON.parse(localStorage.getItem('products'))
    productType = localStorage.getItem('product')
    // eslint-disable-next-line prefer-destructuring
    tenantId = products.filter((p) => p.productName === productType)[0]
  }
  const productName = localStorage.getItem('product')
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [product, setProduct] = useState('')
  const [formData, setFormData] = useState(initialState)
  const [customersList, setCustomersList] = useState([])
  const [assets, setAssets] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [customer, setCustomer] = useState()
  // eslint-disable-next-line no-unused-vars
  const [selectState, setSelectState] = useState()
  // eslint-disable-next-line no-unused-vars
  const [selected, setSelected] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const createReport = (data) => {
    const FilesIssuesHeaders = ['Device Number', 'Device Issue']
    const FileIssuesRaw = data['File errors']
    const FileIssuesIssues = []

    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const [key, value] of Object.entries(FileIssuesRaw)) {
      let rowIssues = value.reduce(
        (string, rowIssue) => `${rowIssue}, ${string}`,
        '',
      )
      rowIssues = rowIssues.slice(0, -1)
      const issue = {
        'Row Number': key,
        'Asset Issue': rowIssues.slice(0, -1),
      }
      FileIssuesIssues.push(issue)
    }
    CreateXlsx('Devices Issues', FilesIssuesHeaders, FileIssuesIssues)
  }

  useEffect(() => {
    if (
      customerSettings !== undefined &&
      customerSettings.tbCustomerId !== undefined
    ) {
      setSelected(true)
      setCustomer(customerSettings.tbCustomerId)
      setSelectState(
        `${customerSettings.tbCustomerId},${customerSettings.title}`,
      )
    }
  }, [])

  useEffect(() => {
    if (userEmail) {
      GetAllCustomers(userEmail, productName).then((data) => {
        console.log('Customer List', data)
        setCustomersList(data || [])
      })
      setProduct(localStorage.getItem('product'))
    }
  }, [userEmail])

  useEffect(() => {
    props.getOpenState('bulk', open)
  }, [open])

  useEffect(() => {
    if (props.open) {
      console.log('custSett', customerSettings)
      if (customerSettings === undefined) setSelected(false)
      setFormData(initialState)
      setOpen(true)
    }
  }, [props.open])

  useEffect(() => {
    ;(async () => {
      if (customer) {
        const queryParams = {
          customerId: customer,
          type: formData.assetType === 'site' ? 'region' : 'zone',
          product,
        }
        Swal.showLoading()
        const res = await getHierarchy(queryParams)
        if (!res.success) Swal.fire('Error grabing assets', '', 'error')
        else {
          if (res.data.length > 0)
            setFormData((prevState) => ({
              ...prevState,
              fromId: res.data[0].id,
            }))
          setAssets(res.data)
          Swal.close()
        }
      }
    })()
  }, [formData.assetType, customer])

  const createMessageContent = (data) => {
    const totalUploadedDevices = (
      <List.Item>
        <IntelMsg id="totalDevices" />
        &nbsp;
        {data['Total no. of failure'] + data['Total no. of success']}
      </List.Item>
    )

    const totalSucessDevices = (
      <List.Item>
        <IntelMsg id="successDevices" />
        &nbsp;{data['Total no. of success']}
      </List.Item>
    )
    const faluireDecvices = (
      <List.Item>Failed Assets:&nbsp;{data['Total no. of failure']} </List.Item>
    )
    return (
      <List bulleted>
        {totalUploadedDevices}
        {totalSucessDevices}
        {faluireDecvices}
      </List>
    )
  }

  const createErrorMessage = (header, content) => {
    const errorMessage = (
      <Message negative>
        <Message.Header>{header}</Message.Header>
        {content}
      </Message>
    )
    setMessage(errorMessage)
  }

  const handleUpload = async (event) => {
    const file = event.target.files[0]
    const queryParams = {
      customerId: customer,
      assetType: formData.assetType,
      fromId: formData.fromId,
      product,
      code: 'spectro-tank-assets',
      tenantId: tenantId.tenantId,
      customerName: selectState.split(',')[1],
    }
    console.log('queryParams: ', queryParams)
    if (file && contains(file.name, '.xlsx')) {
      const res = await uploadAssetFile(queryParams, file)
      if (res.success) {
        dispatch(RefreshCustomerDeviceList(true))
        setMessage('')
        setMessage(
          <Message positive>
            <Message.Header> Result</Message.Header>
            {createMessageContent(res.data)}
            <p>
              Issues report &nbsp;
              <Button size="tiny" onClick={() => createReport(res.data)}>
                <Icon name="download"></Icon>Export
              </Button>
            </p>
          </Message>,
        )
      } else {
        createErrorMessage('Error !', res.msg)
      }
    } else {
      createErrorMessage(
        'Invalid File Type',
        "File extension should be 'xlsx' ",
      )
    }
  }

  const handleCustomerSelect = async (e) => {
    setSelected(true)
    const [id, name] = e.target.value.split(',')
    setCustomer(id)
    setSelectState(e.target.value)
    console.log('m', id, name)
  }

  const handleClose = () => {
    setMessage(null)
    setOpen(false)
  }

  // function createXlsxFile() {
  //   CreateDeviceCreateTemplateXlsx(
  //     localStorage.getItem('product'),
  //     'spectro-tank-assets',
  //     t,
  //   )
  // }

  const handleChange = (e, clearSelect) => {
    e.persist()
    if (clearSelect === true) {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
        fromId: '',
      }))
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }))
    }
  }

  const getAssets = () =>
    assets.map((asset) => (
      <option key={asset.id} value={asset.id}>
        {asset.label || asset.name}
      </option>
    ))

  return (
    <Modal
      closeIcon
      open={open}
      centered
      style={{ position: 'relative', height: 'auto' }}
      onClose={() => handleClose()}
      onOpen={() => setOpen(true)}
    >
      <Header
        icon="archive"
        content=" Hierarchy Level Bulk Upload "
        style={{ backgroundColor: '#1678c2', color: 'white' }}
      />
      <Modal.Content scrolling>
        <Grid columns={2}>
          <Grid.Row style={{ padding: '5px 0' }}>
            <Grid.Column width={4}>
              <span style={{ color: 'black' }}>Customer: </span>
            </Grid.Column>
            <Grid.Column width={2}>
              <select
                name="customer"
                style={{
                  width: 410,
                  height: 40,
                }}
                value={selectState}
                onChange={handleCustomerSelect}
              >
                <option disabled selected>
                  Choose Customer
                </option>
                {customersList.map((item) => (
                  <option
                    key={item.tbCustomerId}
                    value={`${item.tbCustomerId},${item.title}`}
                  >
                    {item.title}
                  </option>
                ))}
              </select>
              <small style={{ color: 'red' }}>**</small>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ padding: '5px 0' }}>
            <Grid.Column width={4}>
              <span style={{ color: 'black' }}>Select Hierarchy Level:</span>
            </Grid.Column>
            <Grid.Column width={2}>
              <select
                name="assetType"
                value={formData.assetType}
                onChange={(e) => handleChange(e, true)}
                style={{
                  width: 410,
                  height: 40,
                }}
                title="Select level to be uploaded"
                disabled={!selected}
              >
                <option value="site">Level 3</option>
                <option value="region">Level 2</option>
              </select>
              <small style={{ color: 'red' }}>**</small>
            </Grid.Column>
          </Grid.Row>
          {assets.length > 0 && (
            <Grid.Row style={{ padding: '5px 0' }}>
              <Grid.Column width={4}>
                <span style={{ color: 'black' }}>
                  Select {formData.assetType === 'site' ? 'Level 2' : 'Level 1'}
                  :{' '}
                </span>
              </Grid.Column>
              <Grid.Column width={2}>
                <select
                  name="fromId"
                  value={formData.fromId}
                  onChange={handleChange}
                  style={{
                    width: 410,
                    height: 40,
                  }}
                  title="Select Parent Level"
                  disabled={!selected}
                >
                  <option value="">Select Level</option>
                  {getAssets()}
                </select>
                <small style={{ color: 'red' }}>**</small>
              </Grid.Column>
            </Grid.Row>
          )}
          <GridRow columns={1}>
            <GridColumn>
              <Segment placeholder>
                <Header icon>
                  <Icon name="cog" />
                  Upload Assets file
                </Header>
                <Segment.Inline>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '29rem',
                      justifyContent: 'space-between',
                    }}
                  >
                    <input
                      type="file"
                      accept=".xlsx"
                      onClick={(event) => {
                        /* eslint-disable-next-line no-param-reassign */
                        event.target.value = null
                      }}
                      onChange={(event) => handleUpload(event)}
                      id="upload"
                      style={{ display: 'none' }}
                      disabled={!selected || formData.fromId === ''}
                    />

                    <label htmlFor="upload">
                      <Button
                        disabled={!selected || formData.fromId === ''}
                        style={{
                          backgroundColor: primaryColor,
                          color: 'white',
                        }}
                        onClick={() =>
                          document.getElementById('upload').click()
                        }
                      >
                        <Icon name="upload" />
                        Upload Excel File
                      </Button>
                    </label>
                    {formData.assetType === 'site' ? (
                      <a
                        href={levelCreation}
                        download="Level-Creation-Template.xlsx"
                      >
                        <Button primary type="button">
                          <Icon name="download" />
                          Download Template
                        </Button>
                      </a>
                    ) : (
                      <a
                        href={levelCreationRegion}
                        download="Level-Creation-Template.xlsx"
                      >
                        <Button primary type="button">
                          <Icon name="download" />
                          Download Template
                        </Button>
                      </a>
                    )}
                  </div>
                </Segment.Inline>
              </Segment>
              {message}
            </GridColumn>
          </GridRow>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="#303d54"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => {
            handleClose()
          }}
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
AssetsBulkUpload.propTypes = {
  getOpenState: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}

export default AssetsBulkUpload
